import { DragIndicatorOutlined } from "@mui/icons-material";
import { Box, Checkbox, FormControlLabel, IconButton, Paper, Typography } from "@mui/material";
import { memo, useEffect, useState } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import PageLayout from "../common/components/PageLayout";
import { createBaseURL } from "../common/util/utils";
import { useCatch } from "../reactHelper";
import { sessionActions } from '../store';
import useReportStyles from "./common/useReportStyles";
import ReportFilter from "./components/ReportFilter";
import ReportsMenu from "./components/ReportsMenu";

const HorizontalReportPage = () => {
    const classes = useReportStyles();
    const dispatch = useDispatch();

    const geofencesState = useSelector((state) => state.geofences.items);
    const user = useSelector((state) => state.session.user);

    const [items, setItems] = useState([]);
    const [eventTypes, setEventTypes] = useState(['geofenceEnter', 'geofenceExit']);

    useEffect(() => {
        const saved = JSON.parse(user?.attributes?.geofencesOrder || '[]');
        const ordered = applySavedOrder(Object.values(geofencesState), saved);
        setItems(ordered);
    }, [geofencesState]);

    const handleCheckboxChange = (id) => {
        const updated = items.map(item =>
            item.id === id ? { ...item, checked: !item.checked } : item
        );
        setItems(updated);
        saveOrder(updated);
        //onChange?.(updated);
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const reordered = Array.from(items);
        const [removed] = reordered.splice(result.source.index, 1);
        reordered.splice(result.destination.index, 0, removed);

        const withUpdatedOrder = reordered.map((item, index) => ({
            ...item,
            order: index
        }));

        setItems(withUpdatedOrder);
        saveOrder(withUpdatedOrder);
        //onChange?.(withUpdatedOrder);
    };

    const handleSubmit = useCatch(async ({ deviceIds, groupIds, from, to, type }) => {
        const query = new URLSearchParams({ from, to });
        deviceIds.forEach((deviceId) => query.append('deviceId', deviceId));

        eventTypes.forEach((it) => query.append('type', it));
        groupIds.forEach((groupId) => query.append('groupId', groupId));
        window.location.assign(`/api/reports/eventsh/xlsx?${query.toString()}`);
    });

    const applySavedOrder = (geofences, savedOrder) => {
        const geofenceMap = geofencesState;

        const ordered = [];
        const order = savedOrder.map(o => ((arr) => ({ id: Number(arr[0]), checked: arr[1] === 'true' }))(o.split('|')));
        const ordered_ids = order.map(o => o.id);
        const missing = geofences.filter(g => !ordered_ids.includes(g.id));
        for (const o of order) {
            ordered.push({ ...geofenceMap[o.id], checked: o.checked });
        }

        ordered.push(...missing.map(m => ({ ...m, checked: false })));

        return ordered;
    }

    const saveOrder = async (newItems) => {
        const ids = newItems.map(i => `${i.id}|${i.checked || false}`);
        // localStorage.setItem("geofenceOrder", JSON.stringify(ids));

        dispatch(sessionActions.updateUser({ ...user, attributes: { ...user.attributes, geofencesOrder: JSON.stringify(ids) } }));
        await updateUser({ ...user, attributes: { ...user.attributes, geofencesOrder: JSON.stringify(ids) } });
    };

    const updateUser = async (user) => {
        const response = await fetch(`${createBaseURL()}/api/users/${user.id}`, {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(user),
        });
    }

    const GeofenceCard = memo(({ item, index, provided, onCheck }) => (
        <Paper
            ref={provided.innerRef}
            {...provided.draggableProps}
            elevation={3}
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                p: 2,
                borderRadius: 2,
            }}
        >
            <Box display="flex" alignItems="center" gap={2}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={item.checked}
                            onChange={() => onCheck(item.id)}
                            color="primary"
                        />
                    }
                    label={
                        <Box display="flex" alignItems="center" gap={1}>
                            <Typography variant="subtitle2" color={`${item.checked ? 'info' : 'error'}`}>
                                Salida?
                            </Typography>
                            <Typography variant="subtitle2" color="primary">
                                |
                            </Typography>
                            <Typography variant="subtitle2" color="text.secondary">
                                #{index + 1}
                            </Typography>
                            <Typography variant="subtitle1">{item.name}</Typography>
                        </Box>
                    }
                />
            </Box>
            <IconButton
                {...provided.dragHandleProps}
                sx={{ color: "text.secondary", cursor: "grab" }}
            >
                <DragIndicatorOutlined />
            </IconButton>
        </Paper >
    ));


    return (
        <PageLayout
            menu={<ReportsMenu />}
            breadcrumbs={['reportTitle', 'reportHorizontal']}
        >
            <div className={classes.container}>
                <div className={classes.containerMain}>
                    <div className={classes.header}>
                        <ReportFilter
                            showOnly
                            multiDevice
                            includeGroups
                            handleSubmit={handleSubmit}
                        />
                    </div>
                    <Box sx={{ width: '40vw', maxWidth: '90%', mx: "auto", p: 2 }}>
                        <DragDropContext onDragEnd={onDragEnd}>
                            <Droppable droppableId="geofences">
                                {(provided) => (
                                    <Box
                                        key={`box`}
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        display="flex"
                                        flexDirection="column"
                                        gap={2}
                                    >
                                        {items.map((item, index) => (
                                            <Draggable
                                                key={item.id}
                                                draggableId={String(item.id)}
                                                index={index}
                                            >
                                                {(provided) => (
                                                    <GeofenceCard
                                                        item={item}
                                                        index={index}
                                                        provided={provided}
                                                        onCheck={handleCheckboxChange}
                                                    />
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </Box>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Box>
                </div>
            </div>
        </PageLayout>
    );
}

export default HorizontalReportPage;